class Common {
  async _init() {
    _$.vue.$on("toplevel", status => {
      const { index } = __.common.tvWindowMetrics

      if (status && index) __.common.tvWindowBehind()
      else __.common._tvWindowSetSize()
    })

    return true
  }

  async setTvWindowSize(position) {
    if (!__.media.player?.multicast) return true

    position.width = 1.5 * position.width
    position.height = 1.5 * position.height
    position.y = 1.5 * position.y
    position.x = 1.5 * position.x
    playmore.vlc.setDisplayMetrics(position.width, position.height, position.y, position.x, position.index ? "FRONT" : "BEHIND")
    return playmore.media.setDisplayMetrics(position.width, position.height, position.y, position.x, position.index ? "FRONT" : "BEHIND")
  }
}

export default Common
